module.exports = __webpack_public_path__ + "RC_Banner-smaller-f401ec0f4a25e994ebb184fcb8a4561f.png";